import { create } from "zustand";
import { persist } from "zustand/middleware";
import { api } from "../lib/api";

interface User {
    id: string;
    email: string;
    name: string;
    role: string;
    permissions: string[];
}

interface AuthState {
    token: string | null;
    user: User | null;
    login: (email: string, password: string) => Promise<boolean>;
    logout: () => void;
    hasPermission: (permission: string) => boolean;
}

export const useAuthStore = create<AuthState>()(
    persist(
        (set, get) => ({
            token: null,
            user: null,

            login: async (email, password) => {
                try {
                    const res = await api.post("/auth/login", { email, password });
                    if (res.data.success) {
                        set({ token: res.data.data.token, user: res.data.data.user });
                        return true;
                    }
                    return false;
                } catch {
                    return false;
                }
            },

            logout: () => {
                set({ token: null, user: null });
            },

            hasPermission: (permission) => {
                const { user } = get();
                if (!user) return false;
                return user.permissions.includes("*") || user.permissions.includes(permission);
            },
        }),
        { name: "elhesn-auth" }
    )
);
